import EmailTagRule from "./email-tag-rule";

export default EmailTagRule;